'use strict'

var Marionette = require('marionette')
var App = require('app')
var ListComponent = require('src/components/list-view')
var _ = require('lodash')

var ListItem = ListComponent.ItemView.extend({
  template: require('./templates/item.html'),
  templateContext: function () {
    var self = this
    return {
      formatTimeFromNow: App.TemplateHelpers.formatTimeFromNow,
      getConditionalStr: App.TemplateHelpers.getConditionalStr,
      getDeviceTypeLabel: App.TemplateHelpers.getDeviceTypeLabel,
      userHasRole: App.TemplateHelpers.userHasRole,
      getHideClasses: App.TemplateHelpers.getHideClasses(self.options),       
      // returns the colimns
      getListColumns: function () {
        return self.options.columns
      },
      // gets called for every column, use this to customize the content of the columns
      getColumnField: function (field) {
        var value = _.get(this, field)
        switch (field) {
          case 'client':
            return App.TemplateHelpers.getClientName(value)
            break
          case 'type':
            return App.TemplateHelpers.getDeviceTypeLabel(value)
            break
          case 'lastSeenAt':
            return App.TemplateHelpers.formatTimeFromNow(value)
            break
          case 'createdAt':
            return App.TemplateHelpers.formatTime(value)
            break
          default:
            return value
            break
        }
      }
    }
  }
})
module.exports.listItem = ListItem

// -- List Component which supports paginating and bulk edit
var listView = ListComponent.ListView.extend({})

module.exports.listView = listView

// -- Layoutview constructing the client-nodes list
var LayoutView = Marionette.View.extend({
  template: require('./templates/layout.html'),
  triggers: {
    'click .js-add': 'client:add',
    'click .js-toggle-list': 'toggle:list',
    'click .js-toggle-map': 'toggle:map'
  },
  regions: {
    listRegion: {
      el: '.list-region',
      replaceElement: false
    }
  },
  initialize: function () {
    var self = this
    this.listenTo(this.collection, 'request', function () {
      self.el.classList.add('loading')
    })

    this.listenTo(this.collection, 'sync add remove', function () {
      setTimeout(function () {
        self.el.classList.remove('loading')
      }, 500)
      self.el.querySelector('.result-header__status .label').innerHTML = 'Your filter returned ' + this.collection.state.totalRecords + ' results.'
    })
  },
  onRender: function () {
    this.el.querySelector('.result-header__status .label').innerHTML = 'Your filter returned ' + this.collection.state.totalRecords + ' results.'
  },
  templateContext: function () {
    var self = this
    return {
      userHasRole: App.TemplateHelpers.userHasRole
    }
  }
})

module.exports.layout = LayoutView



// WEBPACK FOOTER //
// ./js/modules/devices/list/view.js